import { render } from "./BalBtn.vue?vue&type=template&id=5b53c798&scoped=true"
import script from "./BalBtn.vue?vue&type=script&lang=ts"
export * from "./BalBtn.vue?vue&type=script&lang=ts"

import "./BalBtn.vue?vue&type=style&index=0&id=5b53c798&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5b53c798"

export default script